import { Link } from "react-router-dom";
import BootstrapTable from 'react-bootstrap-table-next';
import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import { getPrimes } from '../../../../services/RHService/PrimeService';
import { updatePrime } from '../../../../services/RHService/PrimeService';
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../../../components/layouts/WithLoader";
const Primelist = ({ startLoading, stopLoading }) => {


    //variables
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [data,] = useState([]);
    const [minPrime, setMinPrime] = useState(0);
    const [maxPrime, setMaxPrime] = useState(100);
    const [primes, setPrimes] = useState([]);
    const [selectedPrime, setSelectedPrime] = useState(null);
    const [nomPrime, setNomPrime] = useState("");
    const [iscotisable, setIscotisable] = useState(false);
    const [isimposable, setIsimposable] = useState(false);
    const [fct_presence, setFct_presence] = useState(false);
    const [min, setMin] = useState(0);
    const [max, setMax] = useState(600);
    const [status, setStatus] = useState(false);

    const handleShow = (prime) => {
        console.log("prime", prime);
        setNomPrime(prime.nomPrime);
        setMin(prime.min);
        setMax(prime.max);
        setStatus(prime.status);
        setIscotisable(prime.iscotisable);
        setIsimposable(prime.isimposable);
        setFct_presence(prime.fct_presence);
        setShow(true);
    };
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        startLoading();
        getPrimes(getCurrentUserId()).then((response) => {
            console.log(response)
            if (response.data.success) {
                setPrimes(response.data.success);
            } else {
                setPrimes([])
            }
        }).catch((e) => {
            console.log(e)
        }).finally(() => {
            stopLoading();
        })
    };
    const options = {
        sizePerPage: 5,
        hideSizePerPage: true,
        hidePageListOnlyOnePage: true,
        paginationPosition: "bottom",
    };
    //colonnes de tableau
    const columns = [
        // {
        //     dataField: 'id', text: '#', formatter: (cell, row, rowIndex, formatExtraData) => {
        //         return rowIndex + 1;
        //     }
        // },
        { dataField: 'nomPrime', text: 'Prime' },
        {
            dataField: 'min', text: 'Rang de Montant', formatter: (cell, row) => {
                return (
                    <div className='center' >
                        {row.min} DNT -{row.max} DNT

                    </div>
                );
            }
        },
        {
            dataField: 'status', text: 'Status', formatter: (cell, row) => {
                const badgeClass = row.status ? 'col-greenn' : 'col-orange';
                const badgeText = row.status ? 'Active' : 'Desactive';
                return (
                    <div className='center' >
                        <div className={`badge_leave ${badgeClass}`}>
                            {badgeText}
                        </div>

                    </div>
                );
            }
        },
        {
            dataField: 'iscotisable', text: 'Cotisable', formatter: (cell, row) => {
                const badgeClass = row.iscotisable ? 'fa-check' : 'fa-xmark';
                return (
                    <div className='center' >
                        <Button style={{ "background-color": "white", "color": "black", "border-color": "transparent" }} >
                            <i className={`fa-solid ${badgeClass}`}></i>
                        </Button>

                    </div>
                );
            }
        },
        {
            dataField: 'isimposable', text: 'Imposable', formatter: (cell, row) => {
                const badgeClass = row.isimposable ? 'fa-check' : 'fa-xmark';

                return (
                    <div className='center' >
                        <Button style={{ "background-color": "white", "color": "black", "border-color": "transparent" }} >
                            <i className={`fa-solid ${badgeClass}`}></i>
                        </Button>

                    </div>
                );
            }
        },
        {
            dataField: 'fct_presence', text: 'Fonction de présence', formatter: (cell, row) => {
                const badgeClass = row.fct_presence ? 'fa-check' : 'fa-xmark';

                return (
                    <div className='center' >
                        <Button style={{ "background-color": "white", "color": "black", "border-color": "transparent" }} o>
                            <i className={`fa-solid ${badgeClass}`}></i>
                        </Button>
                    </div>
                );
            }
        },
        {
            dataField: 'actions', text: 'Actions', formatter: (cell, row) => {
                return (
                    <div className='center' >
                        <Button style={{ "background-color": "white", "color": "black", "border-color": "transparent" }} onClick={() => { handleShow(row) }}>
                            <i class="fa-solid fa-pencil" ></i>
                        </Button>

                    </div>
                );
            }
        }
    ];

    const handleUpdate = (event) => {
        event.preventDefault();
        try {
            let formData = {
                idUserCreation: getCurrentUserId(),
                nomPrime: nomPrime,
                min: min,
                max: max,
                iscotisable: iscotisable,
                isimposable: isimposable,
                fct_presence: fct_presence,
            }
            updatePrime(formData).then((response) => {
                console.log("updatePoste", response)
                fetchData();
                handleClose();
            }).catch((e) => {
                console.log(e)
            })

        } catch (error) {
            alert(error.message);
        }
    };
    const handleMinPrimeChange = e => {
        setMinPrime(parseInt(e.target.value));
    };
    const handleMaxPrimeChange = e => {
        setMaxPrime(parseInt(e.target.value));
    };
    const handleMinPriceChange = (event) => {
        setMin(event.target.value);
    };
    const handleMaxPriceChange = (event) => {
        setMax(event.target.value);
    };
    const handleIsCotisableChange = (event) => {
        if (event.target.checked) {
            setIscotisable(true);
        } else {
            setIscotisable(false);

        }

    }
    const handleIsImposableChange = (event) => {
        if (event.target.checked) {
            setIsimposable(true);
        } else {
            setIsimposable(false);

        }

    }
    const handleFctPresenceChange = (event) => {
        if (event.target.checked) {
            setFct_presence(true);
        } else {
            setFct_presence(false);

        }

    }
    const onChangeNomPrimeHandler = (event) => {
        setNomPrime(event.target.value);
    };
    return (
        <div className="content-wrapper" style={{ marginTop: "0" }}>
            <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                // exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                search
            >
                {
                    props => (
                        <div>
                            <Modal show={show} onHide={handleClose} size="lg">
                                <Modal.Header closeButton>
                                    <Modal.Title>Modifier les informations</Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="show-grid">
                                    <Form onSubmit={handleUpdate}>
                                        <Container>
                                            <Row>
                                                <Col xs={12} md={12} >
                                                    <div className="form-group">
                                                        <label htmlFor="inputName">Prime</label>
                                                        <input
                                                            placeholder="Ajouter libellé "
                                                            onChange={onChangeNomPrimeHandler}
                                                            type="text"
                                                            id="inputName"
                                                            value={nomPrime}
                                                            className="form-control"
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label for="exampleInputPassword1">Rang de montant :</label>
                                                        <input
                                                            class="custom-range custom-range-dark"
                                                            type="range"
                                                            name="min"
                                                            min="0"
                                                            max="300"
                                                            value={min}
                                                            onChange={handleMinPriceChange}
                                                        />
                                                        <input
                                                            class="custom-range custom-range-dark"
                                                            type="range"
                                                            name="max"
                                                            min="300"
                                                            max="600"
                                                            value={max}
                                                            onChange={handleMaxPriceChange}
                                                        />


                                                        <label>    Le rang de montant est :  </label>  {min}DT - {max}DT

                                                    </div>
                                                    <div className="form-group">
                                                        <label for="exampleInputPassword1">Status</label>
                                                        <select className="custom-select form-control-border"
                                                            name="status"
                                                            value={status}
                                                            onChange={(e) => {
                                                                setStatus(true);
                                                            }

                                                            }>
                                                            <option value="true">Active</option>
                                                            <option value="false">Désactive</option>
                                                        </select>
                                                    </div>

                                                </Col>
                                                <Col xs={4} md={4} >
                                                    <div className="form-group">
                                                        <label>
                                                            Cotisable
                                                        </label>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            Imposable
                                                        </label>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            Fonction de présence
                                                        </label>
                                                    </div>
                                                </Col>
                                                <div className="col-md-4">
                                                    <div className="card-body">
                                                        <div className="form-group">
                                                            <label>
                                                                <input type="checkbox" name="iscotisable" value={iscotisable} onChange={handleIsCotisableChange} />
                                                            </label>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>
                                                                <input type="checkbox" name="isimposable" value={isimposable} onChange={handleIsImposableChange} />
                                                            </label>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>
                                                                <input type="checkbox" name="fct_presence" value={fct_presence} onChange={handleFctPresenceChange} />
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                        </Container>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleClose}>
                                        Fermer
                                    </Button>
                                    <Button variant="dark" onClick={handleUpdate}>
                                        Modifier
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            <div className="content-header">
                                <div className="container-fluid">
                                    <div className="row mb-2">
                                        <div className="col-sm-6">
                                            <h1 className="m-0">Liste des primes</h1>
                                        </div>
                                        {/* <div className="col-sm-6">
                                            <ol className="breadcrumb float-sm-right">
                                                <li className="breadcrumb-item"><i class="fa-solid fa-house"></i></li>
                                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                                <li className="breadcrumb-item active">Liste des primes</li>
                                            </ol>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            <div class="container-fluid">
                                <div class="card card-dark">
                                    <div class="card-body">
                                        <h5 class="card-title">Ajouter une prime</h5>

                                        <Link to="/addprime" >
                                            <button
                                                class="btn btn-dark  float-right"
                                            >
                                                {" "}
                                                <i class="fas fa-plus"></i>
                                            </button>
                                        </Link>


                                    </div>
                                </div>
                                {/* <div className='row'>
                                    <div className='col-md-9 col-lg-9'></div>
                                    <div className='col-md-3 col-lg-3 right mb-2 '>
                                        <Link to="/settings/addprime" >
                                            <Button type="button" className="btn  btn-dark" style={{ "width": "auto", "margin": "auto" }}>Ajouter une prime
                                            </Button>
                                        </Link>
                                    </div>
                                </div> */}

                                <div class="row">
                                    <div class="col-12">
                                        <div class="card">
                                            <div class="card-header">
                                                <h3 class="card-title">Liste des primes</h3>
                                            </div>
                                            <BootstrapTable keyField='id' data={primes} columns={columns} pagination={paginationFactory(options)} />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </ToolkitProvider >
        </div >
    );
}
export default withLoader(Primelist);